/** Backend phone field constraints (cellPhone, homePhone). */
export const PHONE_MAX_LENGTH = 24;
export const PHONE_MIN_DIGIT_COUNT = 10;

export const countPhoneDigits = (phone: string): number =>
  phone.replace(/\D/g, "").length;

/**
 * Validates a phone number against backend rules:
 * - Max length 24 characters
 * - Must contain at least 10 digits
 *
 * Accepts common formatting (spaces, dashes, parentheses, + prefix).
 */
export const isValidPhoneNumber = (phone: string): boolean => {
  if (!phone || typeof phone !== "string" || phone.trim().length === 0) {
    return false;
  }

  if (phone.length > PHONE_MAX_LENGTH) {
    return false;
  }

  return countPhoneDigits(phone) >= PHONE_MIN_DIGIT_COUNT;
};
